import { call, put, select } from 'redux-saga/effects';
import { getOBD as getOBDAda } from '@bitComponents/adabyron/manager';
import { CONTACT_MEDIUM_TYPE } from '../bitConstants/constants';

const contextStore = state => state.context.data;

const normalizeObdLines = (response) => {
  console.log(response);
  const { subscribedLines, verifiedContactMeans } = response;

  const obdLines = [];
  verifiedContactMeans.forEach((line) => {
    if (line) {
      obdLines.push({
        verifiedContactMeanId: line.id,
        mediumValue: line.value,
        securityMediumType: line.contactTypeTCOL,
      });
    }
  });

  subscribedLines.forEach((line) => {
    if (line) {
      obdLines.push({
        subscribedLineId: line.id,
        mediumValue: line.phoneNumber,
        securityMediumType: CONTACT_MEDIUM_TYPE.SMS,
      });
    }
  });

  return obdLines;
};

export function* getOBD(params) {
  const {
    reduxUpdate,
  } = params;
  const { successUpdate } = reduxUpdate;
  const context = yield select(contextStore);

  const getOBDParams = {
    forzarOBD: false,
    destino: 'https://app.movistar.es/particulares/Aplicaciones/telco/obd/aviso-cliente'
  };

  const response = yield call(getOBDAda, getOBDParams, context);

  const normalizedResponse = normalizeObdLines(response);

  if (successUpdate) {
    yield put(successUpdate(normalizedResponse));
  }

  return normalizedResponse;
}
